/* Zio Tasarla servisi — ürün-bağımsız, temanın her yerinden çağrılan tasarla çekmecesi.
   Sözleşme zio-customize snippet'iyle aynı (§5.1: origin + source kontrolü, açık targetOrigin).
   Durum makinesi: idle → warming → live | failed. Tekrar basma koruması durum makinesinin kendisidir:
   warming'de gelen tıklamalar yalnız bekleyen listesine eklenir, ikinci ısınma asla başlamaz. */
(function () {
  'use strict';
  if (window.ZioTasarla) return;

  var cfgEl = document.getElementById('ZioTasarlaConfig');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var ORIGIN = CFG.origin;
  var ROOT = String(CFG.rootUrl || '/').replace(/\/$/, '');          // '' ya da '/tr'
  var CART_URL = CFG.cartUrl || '/cart';
  var DEFAULT_HANDLE = CFG.defaultHandle;
  var ENGINE_TIMEOUT_MS = 15000;
  var INIT_TIMEOUT_PARAM = 600000;                                    // kabuk init'i sabırla bekler (boot-gate kancası)
  var BREAKPOINT = 768;

  // Ürün sayfası: oradaki zarf (zio-customize) sayfayı sahiplenmiştir; #tasarla tıklaması ona devredilir.
  var pageOwned = !!window.__zioCustomize;

  var state = 'idle';                                                 // idle | warming | live | failed
  var drawer = null, inner = null, frame = null, currentPage = null, swapTimer = null;
  var currentHandle = null, currentPayload = null;
  var basePromise = null, baseCache = null;
  var sceneCache = {}, scenePromises = {};
  var waiters = [];
  var engineTimer = null;
  var pendingOpen = false;                                            // yalnız tıklamayla istenen açılış gerçekleşir
  var appliedSeen = false;                                            // motor init'i uyguladı (sceneReady bekleniyor olabilir)

  // ---------- yardımcılar ----------
  function rootUrl(path) { return ROOT + path; }
  function withWidth(url) {
    // Sahne görselleri: aynı 2000 px, WebP (CDN dönüştürür, tarayıcı desteklemiyorsa PNG döner)
    if (typeof url !== 'string' || !/^(https?:)?\/\//.test(url) || /[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=2000';
  }
  function webpScene(value) {
    if (!value || !value.images) return value;
    var copy = JSON.parse(JSON.stringify(value));
    Object.keys(copy.images).forEach(function (k) { copy.images[k] = withWidth(copy.images[k]); });
    return copy;
  }
  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + url);
      return r.text();
    }).then(function (text) { return JSON.parse(text); });
  }
  function loadBase() {
    if (baseCache) return Promise.resolve(baseCache);
    if (!basePromise) {
      basePromise = fetchJson(rootUrl('/?view=zio-init')).then(function (json) {
        if (!json || json.type !== 'init-base' || !json.config || !Array.isArray(json.products)) throw new Error('init-base geçersiz');
        baseCache = json;
        return json;
      }).catch(function (err) { basePromise = null; throw err; });
    }
    return basePromise;
  }
  function loadScene(handle) {
    if (!/^[a-z0-9-]+$/.test(handle)) return Promise.reject(new Error('geçersiz handle'));
    if (sceneCache[handle]) return Promise.resolve(sceneCache[handle]);
    if (!scenePromises[handle]) {
      scenePromises[handle] = fetchJson(rootUrl('/products/' + handle + '?view=zio-scene')).then(function (value) {
        if (!value || !value.images) throw new Error('sahne yok: ' + handle);
        sceneCache[handle] = value;
        return value;
      }).catch(function (err) { delete scenePromises[handle]; throw err; });
    }
    return scenePromises[handle];
  }
  function assemble(base, scene, handle) {
    var product = null;
    for (var i = 0; i < base.products.length; i++) { if (base.products[i].handle === handle) { product = base.products[i]; break; } }
    if (!product) throw new Error('ürün tasarım gruplarında yok: ' + handle);
    return {
      zio: 1, type: 'init',
      config: base.config,
      products: base.products,
      scene: { handle: handle, value: webpScene(scene) },
      endpoints: base.endpoints,
      prefill: { handle: handle, price: product.price }
    };
  }

  // ---------- tetik loader'ı: temanın hover-button üç-noktası (aynı markup, aynı Motion animasyonu) ----------
  function busy(el, on) {
    if (!el) return;
    if (on) {
      if (el.__zioLoader) return;
      // loader absolute/inset:0 — tetik konumlandırılmamışsa geçici relative (kartın .absolute'u bozulmaz)
      if (getComputedStyle(el).position === 'static') { el.style.position = 'relative'; el.__zioPos = true; }
      var loader = document.createElement('span');
      loader.className = 'btn-loader zio-tasarla-loader';
      loader.innerHTML = '<span></span><span></span><span></span>';
      el.appendChild(loader);
      el.__zioLoader = loader;
      el.setAttribute('aria-busy', 'true');
      el.classList.add('zio-tasarla-busy');
      if (window.Motion && Motion.animate) {
        el.__zioAnim = Motion.animate(loader.children, { transform: ['scale(1.6)', 'scale(0.6)'] },
          { duration: 0.35, delay: Motion.stagger(0.35 / 2), direction: 'alternate', repeat: Infinity });
      }
    } else {
      if (el.__zioAnim) { try { el.__zioAnim.stop(); } catch (e) {} el.__zioAnim = null; }
      if (el.__zioLoader) { el.__zioLoader.remove(); el.__zioLoader = null; }
      if (el.__zioPos) { el.style.position = ''; el.__zioPos = false; }
      el.removeAttribute('aria-busy');
      el.classList.remove('zio-tasarla-busy');
    }
  }
  function addWaiter(el) {
    if (!el || waiters.indexOf(el) > -1) return;
    waiters.push(el);
    busy(el, true);
  }
  function releaseWaiters(openNow) {
    var list = waiters.slice();
    waiters = [];
    list.forEach(function (el) { busy(el, false); });
    var wanted = pendingOpen;
    pendingOpen = false;
    if (openNow && wanted && drawer) showDrawer(list[list.length - 1] || null);
    else if (!openNow && list.length) { try { list[list.length - 1].blur(); } catch (e) {} }
  }

  // ---------- kabuk: temanın kendi çekmece üçlüsü (snippet'le birebir) ----------
  function wantedPage() { return window.innerWidth <= BREAKPOINT ? '/mobile/index.html' : '/web/index.html'; }
  function frameSrc(page) { return ORIGIN + page + '?initTimeout=' + INIT_TIMEOUT_PARAM; }
  function maybeSwapPlatform() {
    clearTimeout(swapTimer);
    swapTimer = setTimeout(function () {
      if (!frame || !drawer || !drawer.open) return;
      var next = wantedPage();
      if (next === currentPage) return;
      currentPage = next;
      if (state === 'live') state = 'warming';                   // yeni sayfa boot olur; ready yeniden canlandırır
      appliedSeen = false;
      armTimer();
      frame.src = frameSrc(next);
    }, 300);
  }
  // açılış: inert'i ANİMASYONDAN ÖNCE kaldır (temanın odak tuzağı ilk odaklanabilir öğeyi hemen arar)
  function showDrawer(button) {
    if (inner) inner.removeAttribute('inert');
    drawer.show(button);
  }
  function buildDrawer() {
    if (drawer) return;
    drawer = document.createElement('drawer-element');
    drawer.id = 'ZioCustomizeDrawer';
    drawer.className = 'drawer drawer--end z-35 fixed bottom-0 left-0 h-full w-full pointer-events-none';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Tasarla');

    var overlay = document.createElement('overlay-element');
    overlay.className = 'overlay fixed-modal invisible opacity-0 fixed bottom-0 left-0 w-full h-screen pointer-events-none';
    overlay.setAttribute('aria-controls', 'ZioCustomizeDrawer');
    overlay.setAttribute('aria-expanded', 'false');

    inner = document.createElement('div');
    inner.className = 'drawer__inner z-10 absolute top-0 flex flex-col w-full h-full overflow-hidden';
    inner.setAttribute('inert', '');            // kapalıyken odak/okuyucu giremez (afterShow kaldırır)
    // Kapalı çekmecede içerik GÖRÜNÜR-şeffaf (opacity 0) + inert; `invisible` (visibility:hidden) YOK:
    // Chrome, visibility:hidden çapraz-kaynak iframe'e işleme fırsatı vermez → motorun img.decode() sözleri
    // askıda kalır, sceneReady hiç gelmez, 15 s zaman aşımı (stok Chrome 151 kanıtı, 2026-08-30).
    // Ekran dışı (transform) kalması sorun değil; inert klavye/erişilebilirlik sızmasını keser.
    var header = document.createElement('gesture-element');
    header.className = 'drawer__header flex justify-between opacity-0 relative';
    header.setAttribute('tabindex', '0');
    var content = document.createElement('div');
    content.className = 'drawer__content opacity-0 flex flex-col h-full grow shrink';

    frame = document.createElement('iframe');
    frame.className = 'zio-frame';
    currentPage = wantedPage();
    frame.src = frameSrc(currentPage);
    frame.setAttribute('allow', 'clipboard-write');
    frame.setAttribute('title', 'Zio Customizer');
    frame.setAttribute('loading', 'eager');
    content.appendChild(frame);

    inner.appendChild(header);
    inner.appendChild(content);
    drawer.appendChild(overlay);
    drawer.appendChild(inner);
    document.body.appendChild(drawer);

    drawer.addEventListener('drawer:afterShow', function () {
      inner.removeAttribute('inert');
      window.addEventListener('resize', maybeSwapPlatform);
      window.addEventListener('orientationchange', maybeSwapPlatform);
      maybeSwapPlatform();
    });
    drawer.addEventListener('drawer:afterHide', function () {
      inner.setAttribute('inert', '');
      window.removeEventListener('resize', maybeSwapPlatform);
      window.removeEventListener('orientationchange', maybeSwapPlatform);
      clearTimeout(swapTimer);
    });
  }
  function sendInit() {
    if (!frame || !currentPayload) return;
    frame.contentWindow.postMessage(currentPayload, ORIGIN);
  }

  // ---------- durum makinesi ----------
  function fail(err) {
    clearTimeout(engineTimer);
    state = 'failed';
    console.error('Zio Tasarla: motor açılamadı —', err && err.message ? err.message : err);
    releaseWaiters(false);
  }
  function goLive() {
    clearTimeout(engineTimer);
    state = 'live';
    applySnapshot();
    releaseWaiters(true);
    pushScenes();
  }
  // ---------- toplu sahne paketi (2026-08-30): tasarım tıkında Shopify'a ürün başına gidiş kalmasın ----------
  // /?view=zio-scenes = { handle: zio.scene } (tüm tasarlanabilir ürünler); boşta bir kez çekilir, motora
  // 'scenes' olarak verilir, sceneCache'e de yazılır (requestScene geri-dönüş yolu da önbellekten döner).
  var scenesPromise = null;
  function pushScenes() {
    if (!scenesPromise) {
      scenesPromise = fetchJson(rootUrl('/?view=zio-scenes')).then(function (all) {
        if (!all || typeof all !== 'object') throw new Error('zio-scenes geçersiz');
        Object.keys(all).forEach(function (h) { if (all[h] && all[h].images) sceneCache[h] = all[h]; });
        return all;
      }).catch(function (err) { scenesPromise = null; console.warn('zio scenes fetch failed:', err); return null; });
    }
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 800); };
    idle(function () {
      scenesPromise.then(function (all) {
        if (!all || !frame || state !== 'live') return;
        var out = {};
        Object.keys(all).forEach(function (h) { out[h] = webpScene(all[h]); });
        frame.contentWindow.postMessage({ zio: 1, type: 'scenes', value: out }, ORIGIN);
      });
    }, { timeout: 3000 });
  }
  // Her motor boot'u (ilk ısınma, Baştan Başla, platform geçişi) aynı sayaçla korunur:
  // sinyal gelmezse asla 'warming'de asılı kalmaz — kurulduysa açar, kurulmadıysa hata verir.
  function armTimer() {
    clearTimeout(engineTimer);
    engineTimer = setTimeout(function () {
      if (appliedSeen) { console.warn('Zio Tasarla: sceneReady gecikti, çekmece açılıyor'); goLive(); }
      else fail(new Error('zaman aşımı (' + ENGINE_TIMEOUT_MS + ' ms)'));
    }, ENGINE_TIMEOUT_MS);
  }
  function warm(handle) {
    state = 'warming';
    currentHandle = handle;
    currentPayload = null;
    appliedSeen = false;
    buildDrawer();                                                   // kabuk (34 KB) hemen iner
    armTimer();
    Promise.all([loadBase(), loadScene(handle)]).then(function (parts) {
      if (currentHandle !== handle) return;                         // bu arada başka ürün istendi
      currentPayload = assemble(parts[0], parts[1], handle);
      sendInit();                                                    // kabuk hazırsa şimdi; değilse 'ready' tekrar gönderir
    }).catch(fail);
  }
  function open(handle, trigger) {
    handle = handle || DEFAULT_HANDLE;
    if (state === 'live' && handle === currentHandle) { showDrawer(trigger || null); return; }
    pendingOpen = true;
    addWaiter(trigger);
    if (state === 'warming' && handle === currentHandle) return;   // tekrar basma: tek ısınma
    warm(handle);
  }

  // ---------- tasarım anlık görüntüsü: ürün başına (snippet'le aynı anahtar) ----------
  function snapshotKey() { return 'zio-snapshot-v2:' + (currentHandle || 'unknown'); }
  var snapshot = null, snapshotTimer = null;
  function readSnapshot() {
    try { var s = sessionStorage.getItem(snapshotKey()); snapshot = s ? JSON.parse(s) : null; } catch (e) { snapshot = null; }
  }
  function writeSnapshot(record) {
    snapshot = record;
    clearTimeout(snapshotTimer);
    snapshotTimer = setTimeout(function () {
      try { sessionStorage.setItem(snapshotKey(), JSON.stringify(snapshot)); } catch (e) {}
    }, 200);
  }
  function clearSnapshot() {
    snapshot = null;
    clearTimeout(snapshotTimer);
    try { sessionStorage.removeItem(snapshotKey()); } catch (e) {}
  }
  function applySnapshot() {
    readSnapshot();
    if (!snapshot || !snapshot.design || !frame) return;
    frame.contentWindow.postMessage({ zio: 1, type: 'apply', design: snapshot.design, sectionId: snapshot.sectionId || null }, ORIGIN);
  }

  // ---------- sahne tedariki (motor başka ürün isteyince) ----------
  function serveScene(handle) {
    if (!/^[a-z0-9-]+$/.test(handle)) return;
    loadScene(handle).then(function (value) {
      if (frame) frame.contentWindow.postMessage({ zio: 1, type: 'scene', handle: handle, value: webpScene(value) }, ORIGIN);
    }).catch(function (err) { console.error('zio scene fetch failed:', handle, err); });
  }

  // ---------- sepet: temanın kendi akışı (snippet'le birebir) ----------
  function bundledSections() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    return sections;
  }
  function attemptAdd(items, attempt) {
    var body = { items: items, sections: bundledSections().join(','), sections_url: window.location.pathname };
    return fetch(rootUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (response.ok) return response.json();
      return response.json().catch(function () { return {}; }).then(function (err) {
        var description = err.description || ('HTTP ' + response.status);
        if (response.status === 422 && attempt < 5 && /sold out|tükendi/i.test(description)) {
          return new Promise(function (resolve) { setTimeout(resolve, 2000); }).then(function () { return attemptAdd(items, attempt + 1); });
        }
        throw new Error(description);
      });
    });
  }
  function openCartDrawer(parsedState) {
    var run = function () {
      return fetch((window.theme && theme.routes && theme.routes.cart_url) || CART_URL, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cartJson) {
          cartJson['sections'] = parsedState['sections'];
          if (window.theme && theme.pubsub) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: parsedState.items && parsedState.items[0] && parsedState.items[0].id, cart: cartJson });
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.show) { drawer.hide(); cartDrawer.show(); return; }
          window.location.href = CART_URL;
        });
    };
    return run().catch(function (err) {
      console.error('cart drawer refresh failed, falling back to /cart:', err);
      window.location.href = CART_URL;
    });
  }

  // ---------- motor mesajları ----------
  window.addEventListener('message', function (ev) {
    if (ev.origin !== ORIGIN) return;
    if (!frame || ev.source !== frame.contentWindow) return;
    var message = ev.data;
    if (!message || message.zio !== 1) return;

    if (message.type === 'ready') {
      sendInit();
      if (message.applied) {
        if (message.handle && currentHandle && message.handle !== currentHandle) return;   // bayat/başka ürün
        appliedSeen = true;
        // El sıkışma: motor 'sceneReady' yollayacağını bildirdiyse görseller boyanana
        // kadar bekle (loader döner); bildirmediyse (eski motor) bugünkü gibi hemen aç.
        if (message.sceneReady === true) return;
        goLive();
      }
      return;
    }
    if (message.type === 'sceneReady') {
      if (message.handle && currentHandle && message.handle !== currentHandle) return;
      if (state === 'warming' && appliedSeen) goLive();
      return;
    }
    if (message.type === 'state') { writeSnapshot({ design: message.design, sectionId: message.sectionId || null, ts: Date.now() }); return; }
    if (message.type === 'reset') {
      clearSnapshot();
      state = 'warming';
      appliedSeen = false;
      armTimer();
      frame.src = frameSrc(currentPage);
      return;
    }
    if (message.type === 'requestScene' && typeof message.handle === 'string') { serveScene(message.handle); return; }
    if (message.type === 'pointer') {
      var frameRect = frame.getBoundingClientRect();
      document.dispatchEvent(new MouseEvent('mousemove', { clientX: frameRect.left + Number(message.x || 0), clientY: frameRect.top + Number(message.y || 0), bubbles: true }));
      return;
    }
    if (message.type === 'cartAction' && message.action && Array.isArray(message.action.items)) {
      attemptAdd(message.action.items, 1)
        .then(function (parsedState) {
          frame.contentWindow.postMessage({ zio: 1, type: 'cartResult', ok: true }, ORIGIN);
          clearSnapshot();
          return openCartDrawer(parsedState);
        })
        .catch(function (err) {
          frame.contentWindow.postMessage({ zio: 1, type: 'cartResult', ok: false, error: String(err).slice(0, 200) }, ORIGIN);
        });
    }
  });

  // ---------- tetikler: adresi #tasarla ile biten linkler ve [data-zio-tasarla] ----------
  function triggerOf(target) {
    var el = target && target.closest ? target.closest('a[href], button[data-zio-tasarla], [data-zio-tasarla]') : null;
    if (!el) return null;
    if (el.hasAttribute('data-zio-tasarla')) return el;
    var href = el.getAttribute('href') || '';
    return /#tasarla$/.test(href) ? el : null;
  }
  function handleOf(el) {
    var explicit = el.getAttribute('data-zio-tasarla');
    if (explicit && /^[a-z0-9-]+$/.test(explicit)) return explicit;
    var m = /\/products\/([a-z0-9-]+)/i.exec(el.getAttribute('href') || '');
    return m ? m[1].toLowerCase() : DEFAULT_HANDLE;
  }
  document.addEventListener('click', function (ev) {
    if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var el = triggerOf(ev.target);
    if (!el) return;
    ev.preventDefault();
    var handle = handleOf(el);
    if (pageOwned) {
      var pageButton = document.querySelector('[data-zio-customize]');
      if (pageButton) { pageButton.click(); return; }
    }
    // 'failed' (zaman aşımı/ağ): ürün sayfasına atmak yerine aynı yerde yeniden ısınma (2026-08-30 kullanıcı kararı:
    // "beklerken ürün sayfasına yönlendirme yok"); tık her zaman canlı — loader döner, motor gelince açılır
    open(handle, el);
  });

  // ---------- boşta ön-ısıtma (2026-08-30 kullanıcı kararı): ürün sayfasındaki prewarm'ın aynısı ----------
  // Sayfa boşa düşünce kabuk + iframe + config/sahne + init → motor 'live' olur (çekmece AÇILMAZ: pendingOpen yok).
  // İlk tık zaten hazır motoru gösterir (Kickflip kalıbı). Ürün sayfasında zarf sahiplenmiştir, orada yapılmaz.
  function prewarm() {
    if (pageOwned || state !== 'idle' || !DEFAULT_HANDLE) return;
    if (navigator.connection && navigator.connection.saveData) return;   // veri tasarrufu: kullanıcı isteyene kadar
    warm(DEFAULT_HANDLE);
  }
  (function () {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
    var kick = function () { idle(prewarm, { timeout: 3000 }); };
    if (document.readyState === 'complete') kick();
    else window.addEventListener('load', kick, { once: true });
  })();

  // instant.page: #tasarla linkleri sayfa geçişi yapmaz; hover ön-yüklemesi (≈700 KB ürün sayfası) boşa gitmesin
  Array.prototype.forEach.call(document.querySelectorAll('a[href$="#tasarla"]'), function (a) { a.setAttribute('data-no-instant', ''); });

  window.ZioTasarla = {
    open: function (handle, trigger) { if (!pageOwned) open(handle, trigger || null); },
    get state() { return state; }
  };
})();
